module.exports = __webpack_public_path__ + "img/logo3.b684d60c.png";